export default __webpack_public_path__ + "static/media/facebook.57f1e49b.svg";